var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.66634H0.5M9.16667 1.33301V3.99967M3.83333 1.33301V3.99967M3.7 14.6663H9.3C10.4201 14.6663 10.9802 14.6663 11.408 14.4484C11.7843 14.2566 12.0903 13.9506 12.282 13.5743C12.5 13.1465 12.5 12.5864 12.5 11.4663V5.86634C12.5 4.74624 12.5 4.18618 12.282 3.75836C12.0903 3.38204 11.7843 3.07607 11.408 2.88433C10.9802 2.66634 10.4201 2.66634 9.3 2.66634H3.7C2.5799 2.66634 2.01984 2.66634 1.59202 2.88433C1.21569 3.07607 0.909734 3.38204 0.717987 3.75836C0.5 4.18618 0.5 4.74624 0.5 5.86634V11.4663C0.5 12.5864 0.5 13.1465 0.717987 13.5743C0.909734 13.9506 1.21569 14.2566 1.59202 14.4484C2.01984 14.6663 2.5799 14.6663 3.7 14.6663Z",
    stroke: "#344054",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallenderIcon);
export default __webpack_public_path__ + "static/media/callender-icon.2359360dce0aed1a76ae2434d831cf37.svg";
export { ForwardRef as ReactComponent };